var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('vSelect',{attrs:{"placeholder":"Couleur","options":[
                { value: 'primary', label: 'Bleu' },
                { value: 'secondary', label: 'Gris' },
                { value: 'success', label: 'Vert' },
                { value: 'danger', label: 'Rouge' },
                { value: 'warning', label: 'Jaune' },
                { value: 'info', label: 'Bleu clair' },
                { value: 'light', label: 'Blanc' },
                { value: 'dark', label: 'Noir' } ],"reduce":function (option) { return option.value; }},scopedSlots:_vm._u([{key:"option",fn:function(ref){
            var label = ref.label;
            var value = ref.value;
return [_c('div',{class:'m-0 p-1 text-center alert alert-'+value},[_vm._v(_vm._s(label))])]}}]),model:{value:(_vm.alertClass),callback:function ($$v) {_vm.alertClass=$$v},expression:"alertClass"}},[_c('div',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Aucune commande ne correspond à votre recherche")])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"alert_class","name":"alert_class"},domProps:{"value":_vm.alertClass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }